import React from "react";
import {
    Card,
    CardContent,
    Link,
    makeStyles,
    Theme,
    Typography,
    Grid,
} from "@material-ui/core";
import { history } from "../../configureStore";
import PlanDocuments from "./Images/PlanDocuments.jpg";
import AnnualReview from "./Images/AnnualReview.jpg";
import MyDetails from "./Images/MyDetails.jpg";
import ClaimsDistributions from "./Images/Claims&Distributions.jpg";
import CommonQuestions from "./Images/CommonQuestions.jpg";
import FeedbackReferrals from "./Images/FeedbackReferrals.jpg";
import ContactUs from "./Images/ContactUs.jpg";
import ActionItems from "./Images/tax-documents.svg"
import { createStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { AccountType } from "../../model";
import { isAdmin } from "../navigation/AdminNavigation";

interface ManagePlanProps {
    mainTitle: string;
    content: string;
    image: string;
    redirectTo: string;
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    cardRootHighlight: {
        background: "linear-gradient(330.33deg, #3DDB93 0%, #1E88E5 100%)",
        boxShadow: "0 0 16px 0 rgba(0,0,0,0.18)",
        color: "#FFFFFF",
    },
    content: {
        display: "flex",
        width: "100%",
    },
    imgSec: {
        paddingRight: 15,
    },
    textSec: {
        padding: "0",
    },
    cardRoot: {
        display: "flow-root",
    },
    cardShadow: {
        boxShadow: "0 0 16px 0 rgba(0,0,0,0.18)",
    },
    cardShadowSec: {
        boxShadow: "0 0 8px 0 rgba(0,0,0,0.21)",
    },
    minHeight: {
        minHeight: 260,
    },
    minHeight170: {
        minHeight: 170,
    },
    minHeight148: {
        minHeight: 148,
    },
    radius8: {
        borderRadius: 8,
    },
    mt25: {
        marginTop: 25,
    },
    mt15: {
        marginTop: 15,
    },
    mb0: {
        marginBottom: 0,
    },
    mb15: {
        marginBottom: 15,
    },
    disPlay: {
        display: "block",
    },
    textLinkNone: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "none",
        },
    },
    w100: {
        width: "100%",
    }
    ,
    textCenter: {
        textAlign: "center",
    },
    floatLeft: {
        float: "left",
    },
    textLight: {
        color: "#9E9E9E",
    },
}));
const ManagePlanData: Array<ManagePlanProps> = [
    {
        mainTitle: "Plan Documents",
        content: "View and download important documents from your plan.",
        image: PlanDocuments,
        redirectTo: "/client/plandocuments",
    },
    {
        mainTitle: "Annual Review",
        content: "Your current plan coverage, returns, and performance.",
        image: AnnualReview,
        redirectTo: "/client/annualreview",
    },
    {
        mainTitle: "Insured Details & Changes",
        content: "Make changes to your personal information, address, beneficiaries, and allocations.",
        image: MyDetails,
        redirectTo: "/client/insured-details",
    },
    {
        mainTitle: "Claims & Distributions",
        content: "Make a claim or distribution request.",
        image: ClaimsDistributions,
        redirectTo: "/client/claims",
    },
    {
        mainTitle: "Common Questions (FAQ)",
        content: "Get answers to questions regarding policies, claims, distributions and more.",
        image: CommonQuestions,
        redirectTo: "/client/questions",
    },
    {
        mainTitle: "Feedback & Referrals",
        content: "Rate your experience or invite someone to learn about this strategy.",
        image: FeedbackReferrals,
        redirectTo: "/client/referralfeedback",
    },
    {
        mainTitle: "Contact us",
        content: "Have a question or need help?",
        image: ContactUs,
        redirectTo: "/client/contactus",
    },
    {
        mainTitle: "Action Items",
        content: "Action Items",
        image: ActionItems,
        redirectTo: "/client/action-items",
    }
];
export default function ManagePlan(props: any) {
    const {user} = useSelector((state: RootState) => state.auth);
    const profile = useSelector((state: RootState) => state.profile);
    const clientPolicy = profile && profile.client && profile.client.clientPolicies && profile.client.clientPolicies.length > 0 && profile.client.clientPolicies[0];
    const classes = useStyles();

    const ManagePlanDataFiltered = ManagePlanData.filter(f => {
        if (f.mainTitle === "Annual Review") {
            return (isAdmin(user))
        }
        return true;
    });

    const redirectTo = (url: string) => {
        history.push(url);
    };



    return (
            <Grid container spacing={2}>
                {
                    [1,2].includes(Number(user.role)) ?
                    ManagePlanDataFiltered.map((o, idx) => (
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={idx}>
                                <Link onClick={() => redirectTo(o.redirectTo)} className={classes.textLinkNone}>
                                    <Card className={classes.radius8 + " " + classes.textCenter + " " + classes.cardShadow + " " + classes.minHeight}>
                                        <div>
                                            <img src={o.image} alt="#" className="mt30"/>
                                        </div>
                                        <CardContent>
                                            <Typography variant="subtitle1" className={classes.mb0}>
                                                <strong>{o.mainTitle}</strong>
                                            </Typography>
                                            <Typography variant="caption" >
                                                {o.content}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>

                    )):
                    ManagePlanDataFiltered.map((o, idx) => (
                            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={idx}>
                                <Link onClick={() => redirectTo(o.redirectTo)} className={classes.textLinkNone}>
                                    <Card className={classes.radius8 + " " + classes.textCenter + " " + classes.cardShadow + " " + classes.minHeight}>
                                        <div>
                                            <img src={o.image} alt="#" className="mt30"/>
                                        </div>
                                        <CardContent>
                                            <Typography variant="subtitle1" className={classes.mb0}>
                                                <strong>{o.mainTitle}</strong>
                                            </Typography>
                                            <Typography variant="caption" >
                                                {o.content}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </Grid>

                    ))
                }
            </Grid>
    );
}

